import React from 'react';
import { clients } from '../mock/mock';

// Renders a real client logo on a clean chip. Falls back to a monogram if the
// logo URL fails to load. Real logos are configured via the `clients` array.
function ClientLogo({ item }) {
  const name = typeof item === 'string' ? item : item.name;
  const logo = typeof item === 'object' ? item.logo : '';
  const [failed, setFailed] = React.useState(!logo);

  return (
    <div className="group glass rounded-2xl p-4 flex flex-col items-center justify-center gap-3 hover:border-[#21A8CB]/45 hover:-translate-y-1 transition-all">
      {!failed ? (
        <div className="w-full h-12 rounded-lg bg-white grid place-items-center px-3">
          <img
            src={logo}
            alt={name}
            className="max-h-8 max-w-[110px] object-contain"
            loading="lazy"
            onError={() => setFailed(true)}
          />
        </div>
      ) : (
        <div className="w-full h-12 rounded-lg bg-gradient-to-br from-[#21A8CB]/25 to-[#8CC53F]/25 grid place-items-center">
          <span className="font-display text-lg font-bold text-slate-900">
            {name.split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase()}
          </span>
        </div>
      )}
      <span className="text-xs font-medium text-slate-600 group-hover:text-slate-900 transition-colors text-center whitespace-nowrap">{name}</span>
    </div>
  );
}

export default function ClientLogos() {
  return (
    <section className="relative max-w-7xl mx-auto px-5 md:px-8 py-14">
      <p className="reveal text-center text-xs font-semibold tracking-[0.25em] uppercase text-slate-500 mb-8">Trusted to Drive Performance</p>
      <div className="reveal grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {clients.map((c, i) => (<ClientLogo key={i} item={c} />))}
      </div>
    </section>
  );
}
